package com.tixforgigs.common.core.util

import com.tixforgigs.common.core.enums.DeviceClass
import kotlinx.browser.window
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.update

object InputUtil {

  val emailRegex = Regex("^[A-Za-z0-9._%+\\-]+@[A-Za-z0-9.\\-]+\\.[A-Za-z]{2,}$")

  /** this regexes are german specific, not international */
  //val houseNumberRegex = Regex("^[1-9][0-9]{0,3}[a-z]?$")
  //val postalCodeRegex = Regex("^(?!00000|01000|99999)(?:0[1-9]\\d{3}|[1-9]\\d{4})\$")

  val mCurrentDeviceClass = MutableStateFlow(getDeviceClass())

  init {
    window.addEventListener("resize", {
      val newDeviceClass = getDeviceClass()
      if (newDeviceClass != mCurrentDeviceClass.value) {
        mCurrentDeviceClass.update { newDeviceClass }
      }
    })
  }

  fun String.toFormattedIBANString(): String {
    return replace("\\s+".toRegex(), "").chunked(4).joinToString(" ").uppercase()
  }

  private fun getDeviceClass(width: Int = window.innerWidth): DeviceClass = when {
    width <= 600 -> DeviceClass.MOBILE
    width <= 1024 -> DeviceClass.TABLET
    width <= 1440 -> DeviceClass.DESKTOP
    else -> DeviceClass.ULTRAWIDE_DEVICE
  }
}